import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { Logo } from '@/components/generals/logo'
import { TrialButton } from '@/components/generals/trial-button'

const NAV_LINKS = [
    { label: 'How it works', href: '/#workflow' },
    { label: 'Oversight', href: '/#oversight' },
    { label: 'Dashboard', href: '/#performance' },
    { label: 'Savings', href: '/#value' }
]

// The floating pill that stays pinned to the top of every page.
export const SiteNav: FC = (): ReactNode => {
    return (
        <header className='pointer-events-none fixed inset-x-0 top-0 z-50 flex justify-center px-4 pt-4 sm:pt-7 lg:pt-10'>
            <nav
                aria-label='Main'
                className='pointer-events-auto flex items-center gap-7 rounded-full border border-black/[0.07] bg-white/85 py-1 pr-1 pl-4 shadow-[0_12px_32px_-16px_rgba(20,23,15,0.3)] backdrop-blur-md motion-safe:animate-intro-drop sm:gap-12 sm:pl-5'
                style={{ animationDelay: '120ms' }}
            >
                <Link
                    href='/'
                    aria-label='Fieldhand home'
                    className='flex items-center self-stretch rounded-full focus-visible:ring-2 focus-visible:ring-moss focus-visible:ring-offset-4 focus-visible:outline-none'
                >
                    <Logo className='translate-y-px' />
                </Link>

                <ul className='hidden items-center gap-1 lg:flex'>
                    {NAV_LINKS.map((link) => (
                        <li key={link.href}>
                            <Link
                                href={link.href}
                                className='rounded-full px-3.5 py-2 text-[15px] font-medium text-ink/75 transition-colors hover:bg-sage hover:text-ink focus-visible:ring-2 focus-visible:ring-moss focus-visible:outline-none'
                            >
                                {link.label}
                            </Link>
                        </li>
                    ))}
                </ul>

                <TrialButton source='nav' className='h-11 px-4 text-[15px] sm:h-12 sm:text-[17px]'>Get started</TrialButton>
            </nav>
        </header>
    )
}
